import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import askConfirmation from 'sharedreact/components/askConfirmation';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import { translate } from 'sharedreact/utils/LanguageSupport';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import TokensActions from 'workspaces/launcher/actions/TokensActions';
import TokensTab from 'workspaces/launcher/components/admin/TokensTab';
import Token from 'workspaces/launcher/data/Token';
import TokensStore from 'workspaces/launcher/stores/TokensStore';
import asFunctional from 'sharedreact/components/asFunctional';

type Props = {
  index: number,
  activeTab: number
};

type State = ConstructorParameters<typeof TokensTab>[0];

function getStores () {
  return [
    SettingsStore,
    TokensStore
  ];
}

function handleLoad () {
}

function handleRevokeToken (token: Token) {
  askConfirmation('tokens_revoke',
    translate('launcher.admin.tokens.revoke.title'),
    translate('launcher.admin.tokens.revoke.message', token.userName))
  .then(() => TokensActions.remove(Immutable.List([token.id])), () => {});
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    index: props.index,
    activeTab: props.activeTab,
    language: SettingsStore.getLanguage(),
    tokens: TokensStore.getItems(),
    selection: TokensStore.getSelection(),
    sortOrder: TokensStore.getSortOrder(),
    onSortOrderChange: TokensActions.setSortOrder,
    setVisibleRange: TokensActions.setVisibleRange,
    onRevokeToken: handleRevokeToken,
    onLoad: handleLoad
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(TokensTab),
  getStores,
  calculateState,
  { withProps: true }
);
